import { PILLARS } from '../data/pillars.js'
import { useUIStore } from '../store/uiStore.js'

/**
 * Pillar tab bar — mirrors q2-goals.html's tab navigation.
 *
 * Reads activePillar from the Zustand store. Any component anywhere
 * in the tree can change which pillar is active via setActivePillar,
 * without prop-drilling through parents.
 */
export default function PillarTabs() {
  const activePillar = useUIStore((s) => s.activePillar)
  const setActivePillar = useUIStore((s) => s.setActivePillar)

  return (
    <div className="pillar-tabs" role="tablist" data-tour="pillar-tabs">
      {PILLARS.map((pillar, i) => (
        <button
          key={pillar.id}
          role="tab"
          aria-selected={i === activePillar}
          className={`pillar-tab ${i === activePillar ? 'active' : ''}`}
          onClick={() => setActivePillar(i)}
        >
          <span className="pillar-tab-icon">{pillar.icon}</span>
          <span>{pillar.name}</span>
          <span className="pillar-tab-count">{pillar.goalCount}</span>
        </button>
      ))}
    </div>
  )
}
